import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _isLoading = new BehaviorSubject<boolean>(false);

  // Expose an Observable that components can subscribe to
  isLoading$: Observable<boolean> = this._isLoading.asObservable();

  constructor() {}

  /**
   * Shows the loader.
   */
  show(): void {
    this._isLoading.next(true);
    // console.log('Loader shown'); // For debugging
  }

  /**
   * Hides the loader.
   */
  hide(): void {
    this._isLoading.next(false);
    // console.log('Loader hidden'); // For debugging
  }
}
